import React from 'react';
import '../style/updateTab.css'
import FormResponseMessage from "./formResponseMessage";
import PreviousApplicationUpdate from "./previousApplicationUpdate";
import GeneralSVG from "./generalSVG";
import moment from 'moment';
import PolicyTabUpdateQuestion from "./ApplicationPolicy/policyTabUpdateQuestion";
import {isSolicitorUser, reduceAnswers} from "../helpers/functions";
import {DROPZONE_ACCEPTED_FILES, isCanada} from "../helpers/variables";
import {UPLOAD_FILE_POLICY_UPDATE_FORM_CA_TOOLTIP} from "../helpers/constants";
import _ from 'lodash';
import { FormGroup, InfoTooltip, Alert, Button, Loader, Heading, HorizontalRule, List, Link } from 'arag-ui-lib';
import '../style/infoTooltip.css'; // Make sure the path is correct
import { formGroupVariants, secondaryVariantStyle } from '../helpers/formGroupVariants';


const UpdateTab = (props) => {
    const {updateQuestions} = props;

    if(props.Store.fetching || props.Store.fetchingLastUpdate || props.Store.fetchingAllPreviousUpdates){
        return (
           <Loader variant={'dots'} />
        )
    }
    if(props.Store.failedToGetQuestions){
        return (
            <FormResponseMessage
                Message={props.Store.failedToGetQuestions}
                CenterWrapper="col-sm-12 mt-15"
                MessageStyle="formResponseMessage-reject"
            />
        )
    }
    return (
        <div className="col-sm-12 updateTab-Wrapper">
            {
                (props.Store.updatePolicy.dateTime && isSolicitorUser(props.userRoles)) && (
                    <div className={'noprintarea'}>
                        <p>
                            {"The form below shows the details of your last update " + moment(props.Store.updatePolicy.dateTime )
                                .format('DD/MM/YYYY - HH:mm:ss') + ". Please provide details of any changes since then by updating your answers below"}
                        </p>
                        <HorizontalRule variant='dotted' className=" appFormRefSettings-hr" />
                    </div>
                )
            }
            {
                (props.UserRole === 'Solicitor' && props.applicationStatus !== 'Rejected') 
                ?
                    <form className="form-horizontal noprintarea" onSubmit={(evt) => props.HandleSubmit(evt, '')}>
                        {
                           _.sortBy(props.Store.questions, ["sortOrder"]).map(question => {
                                if(question.isTopLevel) {
                                    return (
                                        <PolicyTabUpdateQuestion
                                            shouldUpdateQuestionBeMandatory={props.shouldUpdateQuestionBeMandatory}
                                            allQuestions={props.Store.questions}
                                            question={question}
                                            formData={props.Store.formData}
                                            InputWrapper="col-sm-6 formGroup-textInput-input-wrapper"
                                            key={question.id}
                                            Type="text"
                                            HandleFormCompChange={props.HandleFormCompChange}
                                            HandleDateChange={props.HandleDateChange}
                                            OnDrop={props.OnDrop}
                                            onDropMultiple={props.onDropMultiple}
                                            onDropSingle={props.onDropSingle}
                                            HandleSelectChange={props.HandleSelectChange}
                                        />
                                    )
                                } else {
                                    return null
                                }
                            })
                        }
                        <FormGroup
                            labelSize={"col-sm-4"}
                            inputSize={"col-sm-6"}
                            label={"Upload File:"}
                            variant={formGroupVariants.file}
                            inputProps={{
                                label: props.Store.uploadLabel,
                                accepts: DROPZONE_ACCEPTED_FILES,
                                allowMultiple: false,
                                onDrop: props.OnDrop
                            }}
                            formGroupTestId={'upload-file'}
                            secondaryVariantStyle={secondaryVariantStyle}
                        />
                        {
                            isCanada 
                            ?
                                <div className={'col-sm-12 col-sm-offset-10'} style={{bottom: '48px', right: '15px'}} border="100px" >
                                    <InfoTooltip
                                        text={(<div className="InfoTooltip" dangerouslySetInnerHTML={{ __html: UPLOAD_FILE_POLICY_UPDATE_FORM_CA_TOOLTIP }} />)}
                                        variant="info"
                                        style={{border:'15px'}}
                                        miscellaneousCharacter=""
                                        tooltipTestId={'policy-update-upload-file-info'}
                                    />
                                </div> 
                            : 
                                null
                        }           
                        {
                            Object.keys(props.Store.attachments).length > 0
                                ?
                                <>
                                    <div className='col-sm-4'></div>
                                    <Link
                                        variant={'tertiary'}
                                        label={'Remove'}
                                        arrowDirection={'left'}
                                        onClick={() => {
                                            HandleInputChange('attachments', {});
                                            HandleInputChange('tags', '');
                                            HandleInputChange('uploadLabel', 'Drag and drop.')
                                        }}
                                        linkTestId={'policy-update-remove-file'}
                                    />
                                </>
                                :
                                null
                        }
                        <FormGroup
                            labelSize={"col-sm-4"}
                            inputSize="col-sm-6"
                            label={"Add Tags (separate with commas)"}
                            variant={formGroupVariants.text}
                            inputProps={{
                                onChange:(e) => props.HandleInputChange(e.target.name,e.target.value),
                                name: 'tags',
                                value: props.Store.tags,
                                disabled:(Object.keys(props.Store.attachments).length === 0 && props.Store.attachments.constructor === Object)
                            }}
                            formGroupTestId={'add-tags'}
                            secondaryVariantStyle={secondaryVariantStyle}
                        />
                        <div className={'row'}>
                            <div className={'col-sm-9'}>
                                <span>{props.Store.tagsDescription}</span>
                            </div>
                        </div>
                        <div className="form-group">
                            <div className="col-sm-5"> </div>
                            <div className="submit-buttons">
                                <Button 
                                    variant={"tertiary"}
                                    label={"No Changes"}
                                    arrowDirection={"right"}
                                    onClick= {(evt) => {props.HandleSubmit(evt, 'No changes')}}
                                    buttonTestId={"policy-update-no-changes"}
                                />
                                <Button 
                                    variant={"primary"}
                                    label={"Update"}
                                    type={"submit"}
                                    arrowDirection={"right"}
                                    buttonTestId={"policy-update-submit"}
                                />
                            </div>
                        </div>
                        { props.Store.posting ? <Loader variant={'dots'} /> : null }
                        {
                            (props.Store.badMsg !== '') 
                            ?
                                <div className="col-sm-12">
                                    <div className="col-sm-4"></div>
                                    <div  className="col-sm-6">
                                        <Alert variant="error" label={props.Store.badMsg} />
                                    </div>
                                </div>
                            :
                                null
                        }
                        {
                            (props.Store.msg !== '') 
                            ?
                                <div>
                                    <div className="col-sm-4"></div>
                                    <div  className="col-sm-6">
                                        <Alert variant="success" label={props.Store.msg} />
                                    </div>
                                </div>
                            :
                                null
                        }
                    </form>
                :
                    <div className={'noprintarea'}>
                        {
                            props.applicationStatus === 'Rejected' 
                            ?
                                null
                            :
                                <form className="form-horizontal">
                                    <div className="form-group">
                                        <div className="col-sm-5">
                                            <Button 
                                                onClick={(evt) => { props.HandleSubmit(evt, '') }} 
                                                variant={"primary"}
                                                arrowDirection={"right"}
                                                type={"button"}
                                                label={"Request Update"}
                                                buttonTestId={"policy-update-request-update"}
                                            />
                                        </div>
                                    </div>
                                    { props.Store.posting ? <Loader variant={'dots'} /> : null }
                                    {
                                        (props.Store.msg !== '') 
                                        ?
                                            <div className="row col-sm-7">
                                                <Alert variant="success" label={props.Store.msg} />
                                            </div>
                                        :
                                            null
                                    }
                                </form>
                        }
                    </div>
            }
            {props.Store.previousUpdates.length > 0 && (
                <div className='row'>
                    <div className="col-sm-12 noprintarea">
                        <HorizontalRule variant='dotted' className=" applicationPolicy-hr"/>
                    </div>
                    <div className="col-sm-12 noprintarea">
                        <Heading variant={'h4'} className={"col-sm-12"} title={'Previous Updates'} headingTestId='policy-previous-updates-header'/>
                    </div>
                    <div className="col-sm-12 noprintarea">
                        <List
                            id={'applicationPolicy-update-tab-PreviousUpdates-list'}
                            items={
                                props.Store.previousUpdates.map((update, index) => ({
                                    content: <Link
                                        variant={'tertiary'} 
                                        key={index} 
                                        onClick={() => {
                                            props.HandleInputChange('openModal', true);
                                            props.HandleInputChange('selectedPreviousUpdate', update)
                                        }}
                                        label={`${ moment(update.dateTime).format('DD/MM/YYYY - HH:mm:ss')}`}
                                        linkTestID={`policy-previous-update-${index}`}
                                    />,
                                })
                            )}
                        />
                    </div>
                    { props.Store.openModal && (
                        <div className="appFormRefSettings-modal ">
                            <div className="appFormRefSettings-modal-content ">
                                <div
                                    className={"appFormRefSettings-close-button noprintarea"}
                                    onClick={() => props.HandleInputChange('openModal', false)}
                                    data-testid={"policy-previous-update-close"}
                                />
                                    <PreviousApplicationUpdate
                                        Date={moment(props.Store.selectedPreviousUpdate.dateTime).format('DD/MM/YYYY - HH:mm:ss')}
                                        Questions={props.Store.questions}
                                        PreviousUpdate={props.Store.selectedPreviousUpdate}
                                        answers={reduceAnswers(props.Store.selectedPreviousUpdate.policyUpdateAnswersDtos) || {}}
                                    />
                                </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    )
};

export default UpdateTab;